import type { WizardPhase } from './wizardMachine'

// The phase indicator (ATC-133).
//
// State is carried by fill + stroke + text, never by motion and never by colour
// alone — each step also renders its ordinal and its name, so the current step
// is legible without perceiving the accent at all.

const PHASES: { phase: WizardPhase; label: string }[] = [
  { phase: 'collect', label: 'Details' },
  { phase: 'review', label: 'Review' },
  { phase: 'execute', label: 'Execute' },
  { phase: 'result', label: 'Result' },
]

export function WizardSteps({ current }: { current: WizardPhase }) {
  const currentIndex = PHASES.findIndex((p) => p.phase === current)

  return (
    <ol className="rx-wizard-steps">
      {PHASES.map((p, index) => {
        const state =
          index === currentIndex ? 'rx-wizard-step-current' : index < currentIndex ? 'rx-wizard-step-done' : ''
        return (
          <li
            key={p.phase}
            className={`rx-wizard-step ${state}`.trim()}
            aria-current={index === currentIndex ? 'step' : undefined}
          >
            <span className="rx-num">{index + 1}</span> {p.label}
          </li>
        )
      })}
    </ol>
  )
}
